import * as apis from 'services/apis/feedback'
import { logger } from 'utils/logger'

import * as actions from '../actions/Feedback'

export const getFeedbackQuestion = roomName => async dispatch => {
    const msg = 'Failed to fetch feedback questions'
    try {
        dispatch(actions.setFeedbackStateRequest())

        const response = await apis.getFeedbackQuestion(roomName)
        if (response.data.error) {
            logger.error({
                msg,
                error: response.data,
            })
            dispatch(
                actions.setFeedbackStateFailure(
                    `${msg}.\nERROR: ${response.data.error}`
                )
            )
            return
        }

        dispatch(
            actions.setFeedbackStateSuccess(response.data.feedback_question)
        )
    } catch (error) {
        logger.error({
            msg,
            error,
        })
        dispatch(
            actions.setFeedbackStateFailure(`${msg}.\nERROR: ${error.message}`)
        )
    }
}

export const submitFeedback = feedback => async dispatch => {
    const msg = `Failed to add feedback questions`
    try {
        dispatch(actions.setFeedbackStateRequest())

        const response = await apis.submitFeedback(feedback)
        if (response.data.error) {
            logger.error({
                msg,
                error: response.data,
            })
            dispatch(
                actions.setFeedbackStateFailure(
                    `${msg}.\nERROR: ${response.data.error}`
                )
            )
            return
        }

        dispatch(actions.submitFeedbackSuccess(true))
    } catch (error) {
        logger.error({
            msg,
            error,
        })
        dispatch(
            actions.setFeedbackStateFailure(`${msg}.\nERROR: ${error.message}`)
        )
    }
}
